import { CssBaseline, ThemeProvider } from "@mui/material";
import { PropsWithChildren } from "react";
import "./styles/global.css"
import theme from "./styles";

export default function StyleProvider({ children }: PropsWithChildren) {
    return <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
    </ThemeProvider>
}